import { toast } from "react-toastify";
import { formatDate } from "../../utils/rawData/dateValues";
import { ClientTypeColor, PercetageColor, GetStatusClass, PlanBackgroundColor, GetDynamicColor, formMapColor, facturacionMapColor, infoEnviadaMapColor, delayResponsibleMapColor, capacitacionHechaMapColor, statusColorMap } from "../../utils/GetTextColor";
import DetailsButton from "../ui/components/DetailsButton";
import { FaComment, FaEye, FaEyeSlash } from "react-icons/fa";
import Tooltip from "../ui/ToolTip";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import { useRef, useState, useEffect } from "react";
import HandleUpdateSelectSelf from "../../utils/HandleUpdateSelectSelf";
import HandleUpdateSelect from "../../utils/HandleUpdateSelect";
import IdButton from "../ui/components/IdButton";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import { standardServiceStatus } from "../../utils/rawData/serviceStatus";
import OpcionesRecompraPotencial from "../../utils/plainValues/OpcionesRecompraPotencial";
import DinamicBoxButton from "../ui/components/DinamicBoxButton";
import { SiGoogledrive } from "react-icons/si";
import React from "react";
import { createPortal } from "react-dom";
import DrawerCotizacionCalendarioPagosDetails from "../calendarioPagos/DrawerCotizacionCalendarioPagosDetails";


const UiuxRowItemContainer = ({ serviceData, key, c, activeCols, shouldShowColumn, user, permissions, setOpenModalDescription, setSelectedService, setOpenModalComments, uixServices, setClients, stickyOffsets }) => {

  const [s, setS] = useState(serviceData)
  
  // Mantener sincronizado el estado local con los cambios del padre
  useEffect(() => {
    setS(serviceData)
  }, [serviceData])
  const debounceUpdate = useRef(null); // Referencia para mantener el debouncer

  // Drawer cotización
  const [openDrawer, setOpenDrawer] = useState(false);
  const [dataDrawer, setDataDrawer] = useState(null);

  const handleOpenDrawer = async (id) => {
    try {
      const response = await axios.get(`${BACKEND}/api/cotizaciones/${id}`)
      setDataDrawer(response.data)
      setOpenDrawer(true)
    } catch (error) {
      toast.error("Error al obtener la cotización")
    }
  }

  const formStatus = s.form ? s.form.respondido ? "Respondido" : "No respondido" : "No asignado"
  const checklistCompleted = s.checklistCompleted || s.checkList === "Si" ? "Si" : "No"

  const linkFigma = s.linkFigma || ""
  const linkDisenioGrafico = s.linkDisenioGrafico || ""

  const folderCreated = s.folderCreated || false
  const folderId = s.folderId || ""
  const driveUrl = folderCreated && folderId ? `https://drive.google.com/drive/folders/${folderId}` : null

  // Modificación de seleccionables, ya no es solo lectura
  const handleUpdateField = async (field, newStatus) => { // Cambiar el campo
    const changeHistory = s.historialCambios ? [...s.historialCambios] : [];

    const newChange = {
      worker: user,
      field: field,
      oldValue: s[field],
      newValue: newStatus,
      date: new Date().toISOString(),
    };

    changeHistory.push(newChange);

    const transformedHistory = changeHistory.map(change => ({
      ...change,
      worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
    }));

    try {
      await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, {
        [field]: newStatus === "Seleccionar" ? null : newStatus,
        historialCambios: transformedHistory, // Enviar el array actualizado
      });

      // Crear el servicio actualizado
      const updatedService = {
        ...s,
        [field]: newStatus,
        historialCambios: changeHistory,
      };

      // Actualizar el estado local
      setS(updatedService);

      // Actualizar el servicio específico en el array de clientes
      setClients((prevClients) => 
        prevClients.map(client => 
          client.id === c.id 
            ? {
                ...client,
                services: client.services.map(service => 
                  service.id === s.id ? updatedService : service
                )
              }
            : client
        )
      );

      toast.success("Estado actualizado con éxito");
    } catch (error) {
      console.error(error);
      toast.error("Error al actualizar el estado");
    }
  };

  // Modificación de inputs, ya no es solo lectura
  const handleUpdateDate = (field, newDate) => { // Cambiar la fecha con lógica de debouncer

    setS((prevData) => ({
      ...prevData,
      [field]: newDate,
    }));

    if (debounceUpdate.current) {
      clearTimeout(debounceUpdate.current);
    }
    debounceUpdate.current = setTimeout(async () => {

      try {
        const changeHistory = s.historialCambios ? [...s.historialCambios] : [];

        const newChange = {
          worker: user,
          field: field,
          oldValue: s[field],
          newValue: newDate,
          date: new Date().toISOString(),
        };

        changeHistory.push(newChange);

        const transformedHistory = changeHistory.map(change => ({
          ...change,
          worker: change.worker.id, // Solo enviar el id del trabajador, no el objeto completo
        }));

        await axios.put(`${BACKEND}/api/serviciosCotizaciones/${s.id}`, {
          [field]: newDate || null,
          historialCambios: transformedHistory, // Enviar el array actualizado
        });

        // Crear el servicio actualizado
        const updatedService = {
          ...s,
          [field]: newDate,
          historialCambios: changeHistory,
        };

        // Actualizar el estado local
        setS(updatedService);

        // Actualizar el servicio específico en el array de clientes
        setClients((prevClients) => 
          prevClients.map(client => 
            client.id === c.id 
              ? {
                  ...client,
                  services: client.services.map(service => 
                    service.id === s.id ? updatedService : service
                  )
                }
              : client
          )
        );

        toast.success("Dato actualizado con éxito");
      } catch (error) {
        console.error(error);
        toast.error("Error al actualizar la fecha");
      }
    }, 1000); // Esperar 1 sec luego de que el usuario deja de escribir
  };

  // Column definitions (ordered). IDs are assigned automatically as index + 1
  const cols = [
    // 1) Cotización
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-[3.5rem] min-w-[3.5rem] w-[3.5rem] ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } z-10 sticky border border-gray-300 truncate text-center font-semibold hover:cursor-pointer hover:underline transition-all duration-100`} style={{ left: stickyOffsets?.first || '0rem' }}>
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              content={"Abrir cotización"}
              type="eye"
              action={() => handleOpenDrawer(s.cotizacion?.id)}
            />
          </div>
        </td>
      ),
    },

    // 2) Cliente
    {
      content: () => (
        <td scope="row" className={`${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" } sticky z-10 px-2 py-1 max-w-[11rem] font-semibold border border-gray-300 truncate text-start hover:cursor-pointer hover:underline transition-all duration-100`} style={{ left: stickyOffsets?.second || '3.5rem' }}>
          <a href={`/home/seguimiento/${c.id}`} target="_blank" rel="noopener noreferrer">
            <span title={c.nombreComercial} className="whitespace-nowrap text-xs">{c.nombreComercial}{c.vip === "Si" && " ⭐"}</span>
          </a>
        </td>
      ),
    },

    // 3) Ir al proyecto
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          <div className="flex justify-center items-center gap-2">
            <a 
              href={`/home/seguimiento/${serviceData.cotizacion.cliente.id}/${serviceData.servicio.name}/${serviceData.id}`}
              target="_blank" 
              rel="noopener noreferrer"
              className="flex flex-row justify-center items-center gap-2 font-bold hover:cursor-pointer hover:underline transition-all duration-100"
            >
              <DetailsButton content={"Ir al proyecto"} type="externalLink"/>
            </a>
          </div>
        </td>
      ),
    },

    // 4) Regalo
    {
      content: () => (
        <td scope="row" className={`${s.servicioGratuito ? "bg-green-500 font-bold text-white" : "text-gray-200" } px-2 py-1 max-w-xs border border-gray-300 truncate text-center`}>
          {s.servicioGratuito ? `Gratis 🎁` : "No"}
        </td>
      ),
    },

    // 5) Link Drive
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            <DinamicBoxButton
              color={folderCreated && folderId ? "blue" : "gray"}
              action={folderCreated && folderId ? () => {window.open(driveUrl, "_blank", "noopener,noreferrer")} : null}
              content={driveUrl ? driveUrl : "No hay link de Drive"}
              icon={folderCreated && folderId ? <SiGoogledrive className="text-blue-500" /> : <FaEyeSlash className="text-gray-500"/>}
            />
          </div>
        </td>
      ),
    },

    // 6) Recompra potencial
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs ${s.debt ? "bg-red-200" : "bg-white" } border border-gray-300 truncate text-center`}>
          <select
            value={s.cotizacion?.cliente?.recompraPotencial}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            onChange={(e) => {
              HandleUpdateSelect("recompraPotencial", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, recompraPotencial: e.target.value }
                }
              }))
            }}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          >
            {OpcionesRecompraPotencial.map((value) => (
              <option value={value.value} className={`${value.color}`}>{value.icon} {value.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 7) Moroso
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs border border-gray-300 truncate text-center`}>
          <div className="flex justify-center items-center gap-2">
            {s.debt ? (
              <span className="text-red-500 font-bold">
                Si
              </span>
            ) : (
              <span className="text-gray-200">
                No
              </span>
            )}
          </div>
        </td>
      ),
    },

    // 8) ID Cotización
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs font-semibold border border-gray-300 truncate text-center hover:cursor-pointer hover:underline transition-all duration-100`}>
          <div className="flex justify-center items-center gap-2">
            <IdButton content={s.cotizacion.id} type="id" action={() => {CopyToClipBoard(s.cotizacion.id)}} />
          </div>
        </td>
      ),
    },

    // 9) Estado
    {
      content: () => (
        <td
          scope="row"
          className={`px-2 py-1 border border-gray-300 text-center align-middle`}
        >
          <select
            value={s.estado}
            onChange={(e) => {
              const newValue = e.target.value
              if ((!permissions.isAdmin && !permissions.isAssistant) && newValue === "Terminado con exito") {
                return
              }
              handleUpdateField("estado", newValue)
            }}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300 
              ${(!permissions.isAdmin && !permissions.isAssistant) ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}
              ${statusColorMap[s.estado] || ""}
            `}
            disabled={(!permissions.isAdmin && !permissions.isAssistant) && s.estado !== "Terminado con exito"}
            title={(!permissions.isAdmin && !permissions.isAssistant) ? "No tienes permiso para editar el estado" : ""}
          >
            {standardServiceStatus.map((status) => (
              <option value={status.value} className={`${status.color} hover:cursor-pointer`}>{status.icon} {status.label}</option>
            ))}
          </select>
        </td>
      ),
    },

    // 10) Formulario
    {
      content: () => (
        <td scope="row" className={`px-2 py-1 max-w-xs border font-bold border-gray-300 truncate text-center`}>
          <div className="flex justify-center items-center gap-2">
              {formStatus === "Respondido" ? (
                <a 
                  href={`/home/seguimiento/encuestas-respuestas/${s.form.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DetailsButton content={"Abrir formulario"} type="externalLink"/>
                </a>
              ) : (
                <Tooltip content={formStatus} >
                  <div>
                    <FaEyeSlash className="text-gray-500"/>
                  </div>
                </Tooltip>
              )}
          </div>
        </td>
      ),
    },

    // 11) Descripción servicio
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DetailsButton
              action={() => {setOpenModalDescription(true); setSelectedService(s)}}
              content={"Abrir descripción del servicio"}
            />
          </div>
        </td>
      ),
    },

    // 12) Comentarios vendedor
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            {s.comentarioVendedor ? (
              <Tooltip content={s.comentarioVendedor} interactive={true}>
                <div className="flex justify-center items-center text-gray-800 hover:cursor-pointer">
                  <FaComment />
                </div>
              </Tooltip>
            ) : (
              <div className="flex justify-center items-center text-gray-200">
                <FaComment />
              </div>
            )}
          </div>
        </td>
      ),
    },

    // 13) Comentarios operativa
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex justify-center items-center gap-2">
            <DinamicBoxButton
              color={s?.comentariosOperativa?.length > 0 ? "blue" : "gray"}
              action={() => {setOpenModalComments(true); setSelectedService(s)}}
              content={`Abrir comentarios del área operativa: ${s?.comentariosOperativa?.length > 0 ? `${s?.comentariosOperativa?.length}` : "0"}`}
              icon={s?.comentariosOperativa?.length > 0 ? <FaEye /> : <FaEyeSlash />}
            />
          </div>
        </td>
      ),
    },

    // 14) Plan
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`font-semibold px-2 ${PlanBackgroundColor[s.planServicio.name]}`}>
            {s.planServicio.name}
          </span>
        </td>
      ),
    },

    // 15) Encargado
    {
      content: () => (
        <td scope="row" className="max-w-[11rem] px-2 py-1 max-w-xs border border-gray-300 truncate text-start">  
          <span title={s.cotizacion?.cliente?.encargadoProyecto}>{s.cotizacion?.cliente?.encargadoProyecto ? `${s.cotizacion?.cliente?.encargadoProyecto}` : "-"}</span>
        </td>
      ),
    },

    // 16) Nro encargado
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.cotizacion?.cliente?.telefono ? `${s.cotizacion?.cliente?.telefono}` : "-"}
        </td>
      ),
    },

    // 17) Tipo cliente
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <select
            value={s.cotizacion?.cliente?.tipoCliente}
            onChange={(e) => {
              const newValue = e.target.value
              if ((!permissions.isAdmin && !permissions.isUserArea) && newValue === "Terminado con exito") {
                return
              }
              HandleUpdateSelect("tipoCliente", e.target.value, s.cotizacion?.cliente?.id, "clientesUser", setClients)
              setS((prev) => ({
                ...prev,
                cotizacion: {
                  ...prev.cotizacion,
                  cliente: { ...prev.cotizacion?.cliente, tipoCliente: e.target.value }
                }
              }))
            }}
            disabled={!permissions.isAdmin && !permissions.isUserArea}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          >
            <option value="No definido" className="text-gray-500">⚫ No definido</option>
            <option value="Amable" className="text-green-500">🟢	Amable</option>
            <option value="Normal" className="text-blue-500">🔵	 Normal</option>
            <option value="Problematico" className="text-red-500">🔴	 Problematico</option>
          </select>
        </td>
      ),
    },

    // 18) Responsable
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.responsable?.name ? `${s.responsable?.name}` : "-"}
        </td>
      ),
    },

    // 19) Checklist
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <span className={`${checklistCompleted === "Si" ? "text-green-500" : "text-red-500"}`}>
            {checklistCompleted}
          </span>
        </td>
      ),
    },

    // 20) Fecha venta o ingreso
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.fechaIngreso ? formatDate(s.fechaIngreso.split("T")[0]) : "-"}
        </td>
      ),
    },

    // 21) Fecha inicio proyecto
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaInicio ? s.fechaInicio.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaInicio", e.target.value)}
            disabled={!(permissions.isAdmin)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 22) Fecha fin
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <input
            type="date"
            value={s.fechaFin ? s.fechaFin.split('T')[0] : ""}
            onChange={(e) => handleUpdateDate("fechaFin", e.target.value)}
            disabled={!(permissions.isAdmin)}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          />
        </td>
      ),
    },

    // 23) Duración del proyecto establecido
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {Math.ceil((new Date(s.fechaFin).getTime() - new Date(s.fechaInicio).getTime()) / (1000 * 60 * 60 * 24))}
        </td>
      ),
    },

    // 24) Días para la finalización
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.estado === 'Terminado con exito' ? (
            s.fechaFin && s.fechaEntrega ? (
              <span
                className={`font-bold ${
                  Math.ceil((new Date(s.fechaFin).getTime() - new Date(s.fechaEntrega).getTime()) / (1000 * 60 * 60 * 24)) < 0
                    ? 'text-red-500'
                    : 'text-green-500'
                }`}
              >
                {Math.abs(Math.ceil((new Date(s.fechaFin).getTime() - new Date(s.fechaEntrega).getTime()) / (1000 * 60 * 60 * 24)))}
              </span>
            ) : (
              "-"
            )
          ) : (
            s.fechaFin ? (
              <span
                className={`font-bold ${
                  new Date(s.fechaFin).getTime() < new Date().getTime() ? 'text-red-500' : 'text-green-500'
                }`}
              >
                {Math.ceil((new Date(s.fechaFin).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))}
              </span>
            ) : (
              "-"
            )
          )}        
        </td>
      ),
    },

    // 25) Precio venta
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {(() => {
            const servicioEncontrado = uixServices.find(
              (e) => e.id === s.servicio.id
            );

            const precioUnitario = servicioEncontrado?.preciosUnitarios?.find(
              (ev2) => ev2.plan?.id === s.planServicio?.id
            )?.precio;

            const precioBase = s.customPriceActive
              ? s.customPrice * s.numeroItems
              : precioUnitario
              ? precioUnitario * s.numeroItems
              : 0;

            let montoDescuento = 0;
            if (s.tipoDescuento === "Porcentaje") {
              montoDescuento = precioBase * (s.montoDescuento / 100);
            } else if (s.tipoDescuento === "Fijo") {
              montoDescuento = s.montoDescuento;
            }

            return "S/. " + (precioBase - montoDescuento).toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          })()}                      
        </td>
      ),
    },

    // 26) Vendedor
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          {s.cotizacion?.cotizador?.name ? `${s.cotizacion?.cotizador?.name}` : "-"}
        </td>
      ),
    },

    // 27) Control de calidad
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <select
            value={s.controlCalidad}
            disabled={!permissions.isAdmin && !permissions.isAssistant}
            onChange={(e) => {handleUpdateField("controlCalidad", e.target.value)}}
            className={`text-xs rounded-md px-2 py-1 border border-gray-300`}
          >
            <option value="Pendiente" className="text-gray-500">Pendiente</option>
            <option value="Si" className="text-green-500">Si</option>
            <option value="No" className="text-red-500">No</option>
          </select>
        </td>
      ),
    },

    // 28) Link figma
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkFigma ? (
              <DetailsButton 
                action={() => {window.open(linkFigma, "_blank")}}
                content={linkFigma ? linkFigma : "No hay link del figma"}  
              >
                {linkFigma ? linkFigma : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },

    // 29) Link diseño gráfico
    {
      content: () => (
        <td scope="row" className="px-2 py-1 max-w-xs border border-gray-300 truncate text-center">
          <div className="flex items-center justify-center">
            {linkDisenioGrafico ? (
              <DetailsButton
                action={() => {window.open(linkDisenioGrafico, "_blank")}}
                content={linkDisenioGrafico ? linkDisenioGrafico : "No hay link oficial"}  
              >
                {linkDisenioGrafico ? linkDisenioGrafico : "-"}
              </DetailsButton>
            ) : (
              <FaEyeSlash className="text-gray-500"/>
            )}
          </div>
        </td>
      ),
    },
  ]

  const colsWithIds = cols.map((col, index) => ({ ...col, id: index + 1 }))

  return (
    <>
      {createPortal(
        <DrawerCotizacionCalendarioPagosDetails
          onClose={() => setOpenDrawer(false)}
          open={openDrawer}
          dataDrawer={dataDrawer}
          refetch={() => {}}
          isAdmin={permissions.isAdmin}
          paises={[]}
          currencyExchanges={[]}
        />,
        document.body
      )}
      <tr
        key={key}
        className={`text-xs py-2 w-full hover:bg-gray-100 transition-all duration-300 ${s.debt ? "bg-red-200 hover:bg-red-200" : "bg-white" }`}
      >

        {/* Columnas dinámicas (ids 1..N) */}
        {colsWithIds.map((colDef) => {
          const isVisible = activeCols?.find((c) => c.id === colDef.id && shouldShowColumn(c))
          if (!isVisible) return null
          return React.cloneElement(colDef.content(), { key: colDef.id })
        })}

      </tr>
    </>
  )
}

export default UiuxRowItemContainer;
